var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48578 0 0 4.48578 0 10C0 15.5142 4.48578 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48578 15.5142 0 10 0Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6817 12.5043C14.0075 12.8302 14.0075 13.3568 13.6817 13.6827C13.6044 13.7602 13.5126 13.8217 13.4114 13.8636C13.3103 13.9055 13.2019 13.927 13.0924 13.9268C12.8791 13.9268 12.6658 13.8452 12.5033 13.6827L9.99918 11.1784L7.49508 13.6827C7.41779 13.7602 7.32595 13.8217 7.22484 13.8636C7.12373 13.9055 7.01534 13.927 6.9059 13.9269C6.79644 13.927 6.68804 13.9055 6.58692 13.8636C6.48579 13.8217 6.39394 13.7602 6.31664 13.6827C5.99086 13.3568 5.99086 12.8302 6.31664 12.5043L8.8209 10.0002L6.3166 7.49605C5.99082 7.17012 5.99082 6.64352 6.3166 6.31762C6.64254 5.99184 7.16914 5.99184 7.49508 6.31762L9.99918 8.82187L12.5033 6.31758C12.8292 5.9918 13.3558 5.9918 13.6817 6.31758C14.0075 6.64352 14.0075 7.17012 13.6817 7.49605L11.1775 10.0002L13.6817 12.5043Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/CancelButton.2eb1a9c5df8d015a48ac21f23f7253f9.svg";
export { ForwardRef as ReactComponent };